// extracted by mini-css-extract-plugin
export default {"l":"_46867e7f43"};